import { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';

export default {
  maxHeight: 100, // Threshold where the "read-more" button appears
  title: 'Opera',
  type: 'work',
  sections: {
    top: [
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
      {
        id: 'editor_metadata',
        type: 'metadata',
      },
    ],
    content: [
      {
        id: 'metadata',
        type: 'metadata',
      },
      {
        id: 'collection-bibliography',
        type: 'collection',
        grid: 1,
        title: 'resource#bibliography',
        options: {
          classes: 'mr-item-preview-bibliography',
          itemPreview: {
            limit: 9999,
            striptags: false,
          },
        },
      },
      {
        id: 'collection-translations',
        type: 'collection',
        grid: 1,
        title: 'resource#collection_translations',
        options: {
          linkTarget: '_blank',
        }
      },
      {
        id: 'image-viewer-iiif',
        type: 'viewer-iiif',
        title: 'resource#image-viewer-iiif',
        options: {
          libOptions: {
            window: {
              sideBarOpenByDefault: false,
              allowClose: false,
              allowMaximize: true,
              defaultSideBarPanel: 'info',
              views: [
                { key: 'single' },
                { key: 'gallery' },
              ],
              workspaceControlPanel: {
                enabled: false,
              },
            },
            id: 'mirador-container',
          },
        }
      },
    ],
  },
} as ConfigMurucaResourceLayout;
